import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTER_LINKS } from '../consts/app-keys.const';
import { ReactComponent as Disconnect } from '../../../assets/icons/disconnect.svg';

import { Button } from './UI';
import { ArrowLeft } from './icons';
import { InformSpan } from './form';

export const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full flex items-center justify-center bg-surface-base px-[22px] md:px-[72px] md:pt-[118px] md:pb-[86px]">
      <div className="flex flex-col gap-[22px] items-center text-center max-w-[400px] mx-auto">
        <div>
          <Disconnect aria-label="Disconnected icon" />
        </div>

        <h1 className="text-[32px] md:text-[36px] font-display font-medium text-base-black">
          {t('notFound.title')}
        </h1>

        <InformSpan>
          {t('notFound.line1')}
          <br />
          {t('notFound.line2')}
        </InformSpan>

        <Link to={ROUTER_LINKS.ROOT}>
          <Button onClick={() => {}} className="mt-[20px] w-[211px] h-[52px] ">
            <ArrowLeft className="h-[24px] w-[24px]" />
            {t('notFound.backHome')}
          </Button>
        </Link>
      </div>
    </div>
  );
};
